<script setup lang="ts">
import {Tabs, TabsList, TabsTrigger} from "@/core/components/ui/tabs";
import {HistogramInterval, HistogramIntervalOption} from "@/program/interfaces/Program";

const props = defineProps<{
    availableOptions: HistogramIntervalOption;
    default: HistogramInterval;
    disabled: boolean;
}>();

const emits = defineEmits<{
    (e: 'update:interval', value: HistogramInterval): void;
}>();
</script>

<template>
  <Tabs :default-value="props.default" @update:model-value="payload => emits('update:interval', payload as HistogramInterval)">
    <TabsList>
      <TabsTrigger v-for="(label, value) in availableOptions" :key="value" :disabled="disabled" :value="value">
        {{ label }}
      </TabsTrigger>
    </TabsList>
  </Tabs>
</template>

<style scoped>

</style>
